import { Stack, Typography } from '@mui/material';
import React from 'react';
import Image from 'src/components/image';
import PropTypes from 'prop-types';

const FallbackUI = ({ content }) => {
  console.log();
  return (
    <Stack
      sx={{ height: '72vh' }}
      spacing="12px"
      alignItems="center"
      justifyContent="center"
    >
      <Image width={48} height={48} src="/assets/no-data-found.svg" />
      <Typography variant="subheading2" sx={{ textAlign: 'center' }}>
        {content}
      </Typography>
    </Stack>
  );
};

export default FallbackUI;

FallbackUI.propTypes = {
  content: PropTypes.string.isRequired,
};
